import {
	CREATIVE_NAME_KEY,
	CREATIVE_SLOT_KEY,
	KEY_WORDS_KEY,
	PROMO_CART_DETAILS_KEY,
	PROMOTION_ID_KEY,
	PROMOTION_NAME_KEY,
} from '@/data/forReactAndMobile/constants';
import { useMobileApp } from '@/utils/useMobileApp';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

import {
	syncCartPromotionDetailsFromCookies,
	syncKeyWordsFromCookie,
	syncPromotionDetailsFromCookies,
} from './utils';

/**
 * In mobile app flows that rely on WebViews, `sessionStorage` is cleared on every
 * page navigation. To prevent promotion tracking data from being lost, the app
 * temporarily stores promotion details in cookies.
 *
 * This hook runs on mobile only and synchronizes promotion-related data from
 * cookies back into `sessionStorage`, ensuring analytics and tracking events
 * have access to the expected promotion context across page transitions.
 */
export const useSyncMobilePromotionDetails = () => {
	const pathname = usePathname();
	const { isMobileApp } = useMobileApp();
	const [cookies] = useCookies([
		CREATIVE_NAME_KEY,
		CREATIVE_SLOT_KEY,
		KEY_WORDS_KEY,
		PROMOTION_ID_KEY,
		PROMOTION_NAME_KEY,
		PROMO_CART_DETAILS_KEY,
	]);
	useEffect(() => {
		if (!pathname) return;
		if (!isMobileApp) return;

		syncPromotionDetailsFromCookies({
			promotion_id: cookies?.promotion_id,
			promotion_name: cookies?.promotion_name,
			creative_name: cookies?.creative_name,
			creative_slot: cookies?.creative_slot,
		});
		syncCartPromotionDetailsFromCookies({ promoCartDtls: cookies?.promoCartDtls });
		syncKeyWordsFromCookie(cookies?.key_words);
	}, [
		cookies?.creative_name,
		cookies?.creative_slot,
		cookies?.key_words,
		cookies?.promoCartDtls,
		cookies?.promotion_id,
		cookies?.promotion_name,
		isMobileApp,
		pathname,
	]);
};
